(function(){

    /*
    * Inizializzazione e configurazione StickySidebar
    * */
    function boot() {
        const SIDEBAR_SELECTOR = '#sidebar';
        const ACCORDION_SELECTOR = '#accordionCategory'; // id presente nel template
        const DESKTOP_MIN_WIDTH = 992; // <= 991px (tablet e mobile): sticky OFF

        const sidebarEl = document.querySelector(SIDEBAR_SELECTOR);
        if (!sidebarEl || typeof window.StickySidebar === 'undefined') return;

        let stickyInstance = null;

        const requestUpdate = () => {
            if (!stickyInstance) return;

            // StickySidebar ascolta l'evento "update.stickySidebar"
            requestAnimationFrame(() => {
                sidebarEl.dispatchEvent(new CustomEvent('update.stickySidebar'));
            });
        };

        const enableSticky = () => {
            if (stickyInstance) return;

            stickyInstance = new StickySidebar(SIDEBAR_SELECTOR, {
                topSpacing: 80,
                bottomSpacing: 20,
                containerSelector: '.sticky-container',
                innerWrapperSelector: '.sidebar__inner',
                resizeSensor: true,
            });

            // primo ricalcolo “post paint”
            requestUpdate();
        };

        const disableSticky = () => {
            if (!stickyInstance) return;
            stickyInstance.destroy();
            stickyInstance = null;
        };

        // ✅ Sticky SOLO da desktop (>= 992px)
        const mql = window.matchMedia(`(min-width: ${DESKTOP_MIN_WIDTH}px)`);
        const handleMq = (e) => (e.matches ? enableSticky() : disableSticky());

        handleMq(mql);
        if (mql.addEventListener) mql.addEventListener('change', handleMq);
        else if (mql.addListener) mql.addListener(handleMq); // fallback vecchi browser

        // ✅ Update su apertura/chiusura accordion (Bootstrap 5)
        const accordionEl = document.querySelector(ACCORDION_SELECTOR);
        if (accordionEl) {
            accordionEl.addEventListener('shown.bs.collapse', requestUpdate);
            accordionEl.addEventListener('hidden.bs.collapse', requestUpdate);

            // Fallback extra: se per qualche motivo gli eventi BS non arrivano
            accordionEl.addEventListener('click', (e) => {
                const trigger = e.target.closest('[data-bs-toggle="collapse"]');
                if (!trigger) return;
                setTimeout(requestUpdate, 400); // durata tipica animazione collapse
            });
        }

        // ✅ sicurezza: ricalcolo anche a fine load (font/immagini)
        window.addEventListener('load', requestUpdate, { passive: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }


    /*
* Video YT
* */
    document.addEventListener('click', function(e){
        const btn = e.target.closest('.yt-facade__btn');
        if(!btn) return;

        const wrap = btn.closest('.yt-facade');
        const id = wrap && wrap.dataset.ytid;
        if(!id) return;

        const title = wrap.dataset.title || 'YouTube video player';
        const start = wrap.dataset.start || '';

        const params = new URLSearchParams({
            autoplay: '1',
            playsinline: '1',
            rel: '0',
            iv_load_policy: '3',
            controls: '1'
        });

        if (/^\d+$/.test(start)) {
            params.set('start', start);
        }

        const src = "https://www.youtube-nocookie.com/embed/" + encodeURIComponent(id) + "?" + params.toString();

        const iframe = document.createElement('iframe');
        iframe.setAttribute('src', src);
        iframe.setAttribute('title', title);
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe.setAttribute('allowfullscreen', '');
        iframe.style.width = "100%";
        iframe.style.height = "100%";

        wrap.innerHTML = "";
        wrap.appendChild(iframe);
    });


    /*
    * Inizializzazione Swiper.js
    * */
    var swiper = new Swiper(".newsSwiper", {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            "575": {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            "992": {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            "1200": {
                slidesPerView: 3,
                spaceBetween: 15,
            },
        },
    });

})();
